<div class="button-component__arrow-icon">
  <img src="/assets/svg/arrow.svg" alt="" />
</div>
